import { render, staticRenderFns } from "./TabActionButtons.vue?vue&type=template&id=a8805f82&scoped=true"
import script from "./TabActionButtons.vue?vue&type=script&lang=js"
export * from "./TabActionButtons.vue?vue&type=script&lang=js"
import style0 from "./TabActionButtons.vue?vue&type=style&index=0&id=a8805f82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8805f82",
  null
  
)

export default component.exports